import { CSSProperties, ReactElement } from 'react';

import { appColors } from '@backrs_ui/common-ui/src/assets/appColors';

import { Theme, SxProps, Typography, Box } from '@mui/material';

type NuggetArticleProps = Readonly<{
  variant:
    | {
        type: 'SMALL';
        title: string;
        previewImage?: string;
      }
    | {
        type: 'LARGE';
        title: string;
        articleUrl?: string;
        previewImage?: string;
      };
}>;

export const NuggetArticle = ({ variant }: NuggetArticleProps): ReactElement => {
  if (variant.type === 'LARGE') {
    return (
      <>
        {variant.previewImage && (
          <Box sx={imageContainerStyle}>
            <img src={variant.previewImage} alt={variant.title} style={imageStyle} />
          </Box>
        )}
        <Typography
          sx={bottomTextStyle}
          variant="body1"
          onClick={() => window.open(variant.articleUrl, '_blank')}
        >
          {variant.title}
        </Typography>
      </>
    );
  }

  return (
    <>
      {variant.previewImage && (
        <Box sx={imageContainerStyle}>
          <img src={variant.previewImage} alt={variant.title} style={smallImageStyle} />
        </Box>
      )}
    </>
  );
};

const bottomTextStyle: SxProps<Theme> = {
  fontFamily: 'Sarabun',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
  mt: 2,
  textDecoration: 'underline',
  cursor: 'pointer',
  maxWidth: '100%',
  fontStyle: 'italic',
  color: appColors.color.blue1,
};

const imageContainerStyle: SxProps<Theme> = {
  borderRadius: '16px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'hidden',
  width: '100%',
  objectFit: 'cover',
  aspectRatio: '16 / 9',
  borderBottom: '1px solid black',
};

const imageStyle: CSSProperties = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  borderRadius: '16px',
};

const smallImageStyle: CSSProperties = {
  borderRadius: '16px',
  width: '100%',
  objectFit: 'contain',
};
